var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("speech-and-language-annexes", {
    attrs: {
      "full-profile": _vm.fullProfileData,
      "get-appointment-area": _vm.getAppointmentArea,
      "get-disciplines-for-therapy": _vm.getDisciplinesForTherapy,
      "get-goal-list": _vm.getGoalListsByUser,
      "get-objective-list": _vm.getObjectiveListsByUser,
      "save-appointment-area": _vm.saveAppointmentArea
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }